import React from 'react'
import { useEffect } from 'react';
import '../dialog/Dialog.css';

export const Dialog = ({ isOpen, onClose, children, hideCloseButton }) => {
  if (!isOpen) return null;

  return (
    <div className="dialog-overlay"> 
      <div className="dialog-content">
        {!hideCloseButton && (
          <button className="dialog-close" onClick={onClose}>
            X
          </button>
        )}
        {children}
      </div>
    </div>
  );
};